import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { BookingStatusForm } from "./BookingStatusForm";

interface BookingStatusModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  statusId?: string | null;
}

export function BookingStatusModal({ open, onOpenChange, statusId }: BookingStatusModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {statusId ? "Edit Booking Status" : "Add New Booking Status"}
          </DialogTitle>
        </DialogHeader>
        <BookingStatusForm
          statusId={statusId}
          onClose={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}